import React, { Component } from 'react'

export el = React.createElement
